import { Box } from '@mui/material';
import { FsButton } from '../button';
import { DialogWrapper } from '../common/dialogWrapper';
import { useTranslation } from 'react-i18next';
import { FileUploadWrapper } from '../common/fileUploadWrapper';
import { useState } from 'react';
import { UserService } from '../../../services/userService';
import { UserDocumentTypes } from '../../../constants/userDocuments';

export const UploadIBANDocument = ({
	state,
	onClose = (e) => {},
	ibanRequestId = null,
	documentType = UserDocumentTypes.InvestorIban,
}) => {
	const { t } = useTranslation();
	const userService = new UserService();
	const [iBanDetails, setIBanDetails] = useState({});
	const uploadFileType = ['.jpeg', '.png', '.pdf'];
	const [loading, setLoading] = useState(false);

	const onSubmit = () => {
		if (iBanDetails?.file?.url) {
			onClose(true);
		}
	};

	const iBanUrl = () => {
		if (!iBanDetails) {
			return null;
		}

		return iBanDetails?.file;
	};

	const uploadIban = (file) => {
		setLoading(true);
		userService
			.uploadUserDocuments(file, documentType, null, null, {
				...(ibanRequestId && { IbanRequestId: ibanRequestId }),
			})
			.then((resp) => {
				setLoading(false);
				setIBanDetails(resp.data);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<DialogWrapper
				maxWidth="xs"
				width={'380px'}
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={t('uploadIbanDocument')}
				content={
					<Box className="grid grid-flow-row gap-3">
						<FileUploadWrapper
							loading={loading}
							titleText={t('DragIbanToUpload')}
							uploadFileType={uploadFileType}
							onRemoveFile={() => {
								setIBanDetails(null);
							}}
							fileName={iBanUrl()?.name}
							fileExtension={iBanUrl()?.extension}
							imageURL={iBanUrl()?.url}
							onUpload={(file) => {
								uploadIban(file);
							}}></FileUploadWrapper>
					</Box>
				}
				actions={
					<Box className="!w-full text-center">
						<FsButton
							disabled={!iBanDetails?.file?.url}
							type="button"
							loading={loading}
							onClick={() => {
								onSubmit();
							}}>{t('upload&continue')}</FsButton>
					</Box>
				}></DialogWrapper>
		</>
	);
};
